// extracted by mini-css-extract-plugin
module.exports =  {"select":"_xEYVjjYwIU0SoDfYK7S"};